import * as Yup from "yup";
export const validationSchemaFi = Yup.object({
  firstname: Yup.string()
  .trim()
  .required("First name is required. Please provide your first name.")
  .min(2, "First name should be at least 2 characters long."),
lastname: Yup.string()
  .trim()
  .required("Last name is required. Please provide your last name.")
  .min(2, "Last name should be at least 2 characters long."),
    designation: Yup.string()
    .trim()
      .required("Please enter a designation")
      .min(2, "Designation must be at least 2 characters long"),
    phone_number: Yup.string()
      .required("Please enter a phone number")
      .min(10,'Phone number must be exactly 10 digits').max(10, 'MPhone number must be exactly 10 digits')
 
  });
  
  export const validationSchemaSe = Yup.object({
    firstname: Yup.string()
    .trim()
    .required("First name is required. Please provide your first name.")
    .min(2, "First name should be at least 2 characters long."),
  lastname: Yup.string()
    .trim()
    .required("Last name is required. Please provide your last name.")
    .min(2, "Last name should be at least 2 characters long."),
    designation: Yup.string()
    .trim()
      .required("Please enter a designation")
      .min(2, "Designation must be at least 2 characters long"),
    phone_number: Yup.string()
      .required("Please enter a phone number")
      .min(10,'Phone number must be exactly 10 digits').max(10, 'MPhone number must be exactly 10 digits'),
      rrb_id: Yup.string().required("Please select an option"),
      role_id: Yup.string().required("Please select an option")
  });
  export const useralidationSchemaSe = Yup.object({
    firstname: Yup.string()
    .trim()
    .required("First name is required. Please provide your first name.")
    .min(2, "First name should be at least 2 characters long."),
  lastname: Yup.string()
    .trim()
    .required("Last name is required. Please provide your last name.")
    .min(2, "Last name should be at least 2 characters long."),
    designation: Yup.string()
    .trim()
      .required("Please enter a designation")
      .min(2, "Designation must be at least 2 characters long"),
    phone_number: Yup.string()
      .required("Please enter a phone number")
      .min(10,'Phone number must be exactly 10 digits').max(10, 'MPhone number must be exactly 10 digits'),
      rrb_id: Yup.string().required("Please select an option"),
  });
  export const validationSchemaCenFi = Yup.object({
   
    state_id: Yup.string().required("Please select a state"),
    city_id: Yup.string().required("Please select a city"),
    centre_id: Yup.string().required("Please select a center"),
    // cens: Yup.array()
    // //   .of(
    // //     Yup.string()
    // //       .required("CEN number is required")
    // //     //   .notOneOf([""], "CEN number cannot be empty")
    // //   )
    //   .required("Please Enter CEN Number")
    //   .test("no-empty-strings", "CEN number cannot be empty", (value) => {
    //     // Check if any element in the array is an empty string
    //     return value ? !value.includes("") : true;
    //   }),
  });
  export const validationSchemaCenSe = Yup.object({
    rrb_id: Yup.string().required("Please select an RRB"),
    state_id: Yup.string().required("Please select a state"),
    city_id: Yup.string().required("Please select a city"),
    centre_id: Yup.string().required("Please select a center"),
    // cens: Yup.array()
    // .of(
    //   Yup.string()
    //     .required("CEN number is required")
    //     .notOneOf([""], "CEN number cannot be empty")
    // )
    // .required("Please Enter CEN Number")
    // .test(
    //   "no-empty-strings",
    //   "CEN number cannot be empty",
    //   (value) => value && !value.some((item) => item?.trim() === "")
    // )
  });